/* eslint-disable complexity, react-hooks/exhaustive-deps */

import { useCallback, useEffect } from 'react';
import { branch, renderNothing } from 'recompose';

import log from '../../config/app.logger';

import { CookieChangeEvent, CookieList, CookieListItem, CookieListeners } from './types';

function isCookieStoreAvailable() {
  if ('cookieStore' in window) {
    log('cookieStore available, cookie change listeners will be registered');
    return true;
  }
  log('cookieStore not available, skipping cookie change listeners');

  return false;
}

function CookieChangeListener(props: CookieListeners) {
  const { onChange, onDelete, cookiesToMonitor = [] } = props;

  const needToNotify = useCallback(
    (cookies: CookieList) =>
      cookies.find(({ name }: CookieListItem) => cookiesToMonitor.includes(name!)),
    [cookiesToMonitor]
  );

  const onCookieChange = useCallback((event: CookieChangeEvent) => {
    if (event.changed?.length && onChange && needToNotify(event.changed)) {
      onChange(event.changed);
    }

    if (event.deleted?.length && onDelete && needToNotify(event.deleted)) {
      onDelete(event.deleted);
    }
  }, []) as EventListener;

  const registerHandlers = useCallback(() => {
    window.cookieStore.addEventListener('change', onCookieChange);
  }, []);

  const unregisterHandlers = useCallback(() => {
    window.cookieStore.removeEventListener('change', onCookieChange);
  }, []);

  useEffect(() => {
    registerHandlers();
    return unregisterHandlers;
  });
  return null;
}

export default branch<CookieListeners>(
  () => !isCookieStoreAvailable(),
  renderNothing
)(CookieChangeListener);
